import { observable } from "mobx";

class Product {
  /**
   * @property {number|null}
   */
  @observable productId = null;

  /**
   * @property {string}
   */
  @observable name = "";

  /**
   * @property {number}
   */
  @observable creditCost = 0;

  /**
   * @property {number}
   */
  @observable discountedCreditCost = 0;

  constructor({ productId = null, name = "", creditCost = 0, discountedCreditCost = 0 }) {
    this.productId = productId;
    this.name = name;
    this.creditCost = creditCost;
    this.discountedCreditCost = discountedCreditCost;
  }
}

export default Product;
